import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../assets/css/signin.scss'
import { Link } from 'react-router-dom';
import googleIcon from '../assets/images/signin/google.png'
import linkedIcon from '../assets/images/signin/linkedin.png'
import companyLogo from '../assets/images/signin/logo-dark-copy.png'
import { postSignInUserData } from './redux/action';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as HeaderAuthentication from '../components/HeaderAuthentication';
import bannerMain from '../assets/images/Signin_Banner.png';
import shieldIcon from '../assets/images/shield.png';
import ChartColumnIcon from '../assets/images/chartColumn.png';
import locationIcon from '../assets/images/locationIcon.png';
import usersIcon from '../assets/images/usersIcon.png';
import { baseURL } from './BaseURL';

const SignIn = () => {
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const [showPassword, setShowPassword] = useState(false);
    const [signInStatus, setSignInStatus] = useState(false)
    const tokenClientRef = useRef(null);
    // let hideSwal = false;
    const hideSwal = useRef(false);

    const [planExpired, setPlanExpired] = useState(false);
    const [expireDetails, setExpireDetails] = useState("");
    const [authLogin, setAuthLogin] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("socialLogin")) {
            setAuthLogin(true);
        }
    }, []);

    const [formData, setFormData] = useState({
        email: '',
        pswd: ''
    });

    const [errors, setErrors] = useState({});
    const [rememberMe, setRememberMe] = useState(false);

    useEffect(() => {
        return () => {
            tokenClientRef.current = null;
        };
    }, []);


    // region google initialize
    const handleGoogleCallback = async (tokenResponse) => {
        try {
            const res = await fetch(
                "https://people.googleapis.com/v1/people/me?personFields=phoneNumbers,emailAddresses,names",
                {
                    headers: {
                        Authorization: `Bearer ${tokenResponse.access_token}`,
                    },
                }
            );

            const data = await res.json();

            const userData = {
                name: data.names?.[0]?.displayName || "",
                email: data.emailAddresses?.[0]?.value || "",
                phoneNumber: data.phoneNumbers?.[0]?.value || "",
            };

            hideSwal.current = true;

            addSignIn(userData);
        } catch (error) {
            console.error(error);
        }
    };

    const initializeGoogleClient = () => {
        if (!window.google?.accounts?.oauth2) {
            console.log("Google SDK not loaded");
            return false;
        }

        tokenClientRef.current =
            window.google.accounts.oauth2.initTokenClient({
                client_id: '762425997431-plapsidtr0nm2kjfkc9vrk6vcv2lsfa2.apps.googleusercontent.com',
                scope:
                    "openid profile email https://www.googleapis.com/auth/user.phonenumbers.read",
                callback: handleGoogleCallback,
            });

        console.log("Google Client Initialized");

        return true;
    };

    useEffect(() => {
        if (window.google?.accounts?.oauth2) {
            initializeGoogleClient();
            return;
        }

        const interval = setInterval(() => {
            if (window.google?.accounts?.oauth2) {
                clearInterval(interval);
                initializeGoogleClient();
            }
        }, 300);

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // endregion

    // Load credentials from localStorage on mount
    useEffect(() => {
        const rememberedCredentials = JSON.parse(localStorage.getItem("rememberedCredentials"));
        if (rememberedCredentials) {
            setFormData({
                EmailID: rememberedCredentials.email,
                Password: rememberedCredentials.pswd
            });
            setRememberMe(true);
        }
    }, []);

    // Handle "Remember me" toggle
    const toggleRememberMe = () => {
        setRememberMe(!rememberMe);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        }
        if (!formData.pswd.trim()) {
            newErrors.pswd = 'Password is required';
        }
        return newErrors;
    };

    const handleLogin = (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setSignInStatus(true)

        const signInData = {
            email: formData.email,
            pswd: formData.pswd
        };

        if (rememberMe) {
            const credentials = {
                email: formData.email,
                pswd: formData.pswd,
                remember: rememberMe
            };
            localStorage.setItem("rememberedCredentials", JSON.stringify(credentials));
        } else {
            localStorage.removeItem("rememberedCredentials");
        }

        addSignIn(signInData);
    };

    const addSignIn = (data) => {
        console.log(data, 'data')
        const signInData = {
            email: data.email,
            pswd: data.pswd
        };

        if (rememberMe) {
            const credentials = {
                email: data.email,
                pswd: data.pswd,
                remember: rememberMe
            };
            localStorage.setItem("rememberedCredentials", JSON.stringify(credentials));
        } else {
            localStorage.removeItem("rememberedCredentials");
        }

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(signInData),
        };
        dispatch(postSignInUserData(requestOption, hideSwal.current, data.email, data.name, data.phoneNumber, setPlanExpired, setExpireDetails)).then(
            (resp) => {
                setSignInStatus(false);
            }
        ).catch((err) => {
            setSignInStatus(false);
            sessionStorage.removeItem("socialLogin");
            setAuthLogin(false);
        });

    };

    const handleGetPhone = () => {
        if (!tokenClientRef.current) {
            console.log("Reinitializing Google Client...");

            const initialized = initializeGoogleClient();

            if (!initialized) {
                console.error("Google SDK not ready");
                return;
            }
        }

        tokenClientRef.current.requestAccessToken({
            prompt: "select_account",
        });
    };

    const handleLinkedInLogin = () => {
        const clientId = "86opkgjrw1jcp4";
        // const redirectUri = `https://gfcb8ed8eb8355a-st94sy8hnd7n7e0g.adb.ap-mumbai-1.oraclecloudapps.com/ords/leadmerge/lm_login/oauth/linkedin/callback`;
        const redirectUri = `${baseURL}/lm_login/oauth/linkedin/callback`;

        const email = "";

        const stateObj = { email: email, ts: Date.now() };
        const state = btoa(JSON.stringify(stateObj));
        const scope = "openid profile email";

        const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
            redirectUri
        )}&scope=${encodeURIComponent(scope)}&state=${state}`;

        sessionStorage.setItem("socialLogin", "linkedin");
        window.location.href = authUrl;
    };

    useEffect(() => {
        const params = new URLSearchParams(
            window.location.search
        );

        if (params) {
            if (params.get("email")) {
                const user = {
                    linkedinId: params.get("id"),
                    name: params.get("name"),
                    email: params.get("email"),
                    picture: params.get("picture")
                };

                const signUpData = {
                    name: user.name,
                    mobile_code: "",
                    email: user.email,
                    phoneNumber: "",
                    company_name: "",
                };
                hideSwal.current = true;
                addSignIn(signUpData);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
                formRef.current?.requestSubmit();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    return (
        <Container fluid className="signin-container">
            {authLogin && (
                <div className="social-loader-overlay">
                    <div className="social-loader-content">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>

                        <h5 className="mt-3">Signing in</h5>
                        <p>Please wait while we redirect you...</p>
                    </div>
                </div>
            )}
            <Row className="signin-row">

                <Col md={6} className="signin-first-col signinLeftContent">
                    <div className="hero-shape">
                        <div className="dot-pattern"></div>
                    </div>
                    <img src={companyLogo} className='signinCompanyLogo' alt="" />
                    <div>
                        <h6>AI-Powered Marketing</h6>
                        <h4><span>Better </span>Leads. Bigger Growth.</h4>
                        <p>LeadMerge helps B2B businesses generate high-quality leads,
                            optimize campaigns, and maximize ROI with AI-driven insights.</p>
                        <div className="myBannerSection">
                            <div className="features-list">

                                <div className="feature-item">
                                    <div className="feature-icon">
                                        {/* <i className="fa-solid fa-user-group"></i> */}
                                        <img src={usersIcon} className='shieldImage' alt="usersIcon" />
                                    </div>
                                    <div className="feature-content">
                                        <h4>High-Quality Leads</h4>
                                        <p>Reach the right audience and boost conversions.</p>
                                    </div>
                                </div>

                                <div className="feature-item">
                                    <div className="feature-icon">
                                        {/* <i className="fa-solid fa-crosshairs"></i> */}
                                        <img src={locationIcon} className='shieldImage' alt="locationIcon" />
                                    </div>
                                    <div className="feature-content">
                                        <h4>Smart Campaigns</h4>
                                        <p>AI-optimized campaigns for better performance.</p>
                                    </div>
                                </div>

                                <div className="feature-item">
                                    <div className="feature-icon">
                                        {/* <i className="fa-solid fa-chart-column"></i> */}
                                        <img src={ChartColumnIcon} className='shieldImage' alt="ChartColumnIcon" />
                                    </div>
                                    <div className="feature-content">
                                        <h4>Maximize ROI</h4>
                                        <p>Data-driven insights to grow your business.</p>
                                    </div>
                                </div>

                                <div className="feature-item">
                                    <div className="feature-icon">
                                        <img src={shieldIcon} className='shieldImage' alt="shieldIcon" />
                                    </div>
                                    <div className="feature-content">
                                        <h4>Secure & Reliable</h4>
                                        <p>Enterprise-grade security for your data.</p>
                                    </div>
                                </div>

                            </div>
                            <div className="bannerContent">
                                <img src={bannerMain} className='bannerMianImage' alt="Banner" />
                            </div>
                        </div>
                    </div>

                </Col>

                <Col md={6} className="signin-second-col">
                    <div className='formSection'>
                        <div className="loginIcon">
                            <img src={shieldIcon} className='shieldImage' alt="shieldIcon" />
                            {/* <i className="fa-regular fa-shield-check"></i> */}
                        </div>

                        <h3 className="mb-4 text-center">Welcome Back!</h3>
                        <p>Sign in to your LeadMerge account.</p>
                        <Form ref={formRef} className='signin-form-container' onSubmit={handleLogin}>
                            <Form.Group className="mb-3 position-relative" controlId="formEmail">
                                <i className="fa-regular fa-envelope inputIcon"></i>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                                {errors.email && <div className="text-danger">{errors.email}</div>}
                            </Form.Group>
                            <Form.Group controlId="formPassword" className="position-relative">
                                <i className="fa-solid fa-lock inputIcon"></i>
                                <Form.Control
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter password"
                                    name="pswd"
                                    value={formData.pswd}
                                    onChange={handleChange}
                                    className="pe-5"
                                />
                                <i
                                    className={`fa ${!showPassword ? "fa-eye-slash" : "fa-eye"} toggle-eye`}
                                    onClick={() => setShowPassword(!showPassword)}
                                ></i>
                                {errors.pswd && <div className="text-danger mt-1">{errors.pswd}</div>}
                            </Form.Group>

                            <div className="forgot-pass-n-remind-me">
                                {/* <div className="signIn-footer ">
                                    <div className="create-account-div d-flex align-items-center">
                                        <input
                                            type="checkbox"
                                            checked={rememberMe}
                                            onChange={toggleRememberMe}
                                        />&nbsp;&nbsp;
                                        <div
                                            className="login-remember-me"
                                        >
                                            Remember my preferences
                                        </div>
                                    </div>
                                </div> */}
                                <div className="forget-pasword-div">
                                    <Link
                                        to="/forget-password"
                                        className="lm-pswd-reset"
                                    >
                                        Forgot Password?
                                    </Link>
                                </div>
                            </div>

                            <Button variant="primary" type="submit" className="w-100" disabled={signInStatus}>
                                {signInStatus ? "Processing..." : "Sign In"}
                            </Button>

                            <div className="divider-container">
                                <div className="line"></div>
                                <p className="text">Or continue with</p>
                                <div className="line"></div>
                            </div>

                            <div className='lm-login-btns-section'>
                                <div className='btn-div' onClick={handleGetPhone}>
                                    <img src={googleIcon} alt="" /> &nbsp; Google
                                </div>
                                <div className='btn-div' onClick={handleLinkedInLogin}>
                                    <img src={linkedIcon} alt="LinkedinIcon" />&nbsp; Linkedin
                                </div>
                            </div>
                            <div className='signin-signup-link'>
                                <p>Don't have an account? <Link to='/signup'> Sign Up </Link></p>
                            </div>
                        </Form>
                    </div>
                </Col>
                <div className="copyright_text">
                    <h6>Copyright @ 2026 <span>Leadmerge LLC</span></h6>
                </div>
            </Row>

        </Container>
    );
};

export default SignIn;
